/* eslint-disable react/jsx-no-target-blank */
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'

import Select from 'react-select'
import {ToastContainer} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons'
import {Tr} from '../../../../_metronic/i18n/Tr'

export function AddVendor(props: any) {
  let t = Tr()

  return (
    <>
      <ToastContainer />
      <div
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        id='kt_login_signup_form'
      >
        {/* <!--begin::Input group--> */}
        <div className='row mb-8'>
          {/* <!--begin::Col--> */}
          <div className='col-lg-12'>
            {/* <!--begin::Image input--> */}
            <div
              className='image-input image-input-outline '
              data-kt-image-input='true'
              id='profilePicture'
            >
              <img
                alt='images'
                id='previewImage'
                className='image-input-wrapper w-125px h-125px changeimg pointer'
                src={
                  props.profilePicture
                    ? URL.createObjectURL(props.profilePicture)
                    : props.imageUrl === '' || props.imageUrl === null
                    ? toAbsoluteUrl('/media/avatars/300-1.jpg')
                    : props.imageUrl
                }
              />

              <label
                className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                data-kt-image-input-action='change'
                data-bs-toggle='tooltip'
                title=''
                data-bs-original-title='Change avatar'
              >
                <i className='fa fa-edit'></i>
                {/* <!--begin::Inputs--> */}
                <input
                  type='file'
                  name='image'
                  id='profileImage'
                  accept='.png, .jpg, .jpeg'
                  style={{display: 'none'}}
                  onChange={(e: any) => {
                    if (e.target.files[0] != null && e.target.files[0] != undefined) {
                      props.setProfilePicture(e.target.files[0])
                      props.removeError('profilePicture')
                    }
                  }}
                />
                <input type='hidden' name='avatar_remove' />
                {/* <!--end::Inputs--> */}
              </label>
              {/* <!--end::Label--> */}
            </div>
            {/* <!--end::Image input--> */}
            {/* <!--begin::Hint--> */}
            <div className='form-text' id='validimage'>
              {t('Allowed file types: png, jpg, jpeg.')}
            </div>
            {/* <!--end::Hint--> */}
            <div className='text-danger fw-bold'>{props.error[0].profilePicture}</div>
          </div>
          {/* <!--end::Col--> */}
        </div>
        {/* <!--end::Input group--> */}
        {/* begin::Form group Firstname */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Full Name')}</label>
          <input
            placeholder={t('Full Name')}
            type='text'
            id='fullName'
            autoComplete='off'
            className='form-control bg-transparent'
            value={props.fullName}
            onChange={(e: any) => {
              props.setFullName(e.target.value)
              props.removeError('fullName')
            }}
          />
          <div className='text-danger fw-bold'>{props.error[0].fullName}</div>
        </div>

        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>
            {t('Select Your Service')}
          </label>
          <Select
            name='category[]'
            id='categoryId'
            placeholder={t('Select Your Service')}
            isSearchable={true}
            options={props.categoryList}
            value={props.categorySelectedOptions}
            onChange={(e: any) => {
              props.setCategorySelectedOptions(e)
              props.removeError('categoryId')
            }}
          />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{props.error[0].categoryId}</div>
        </div>
        {/* end::Form group */}
        <div className='fv-row mb-8'>
          {/* begin::Form group Lastname */}
          <label className='form-label fw-bolder text-dark fs-6 required'>
            {t('Mobile Number')}
          </label>
          <div id='phoneNumber'>
            <PhoneInput
              inputClass='form-control form-control-solid w-100'
              placeholder={t('Enter Mobile Number')}
              enableSearch={true}
              value={props.phoneNumber}
              country={props.countryCode}
              onChange={props.handleChange}
            />
          </div>
          {/* end::Form group */}
          <div className='text-danger fw-bold'>{props.error[0].phoneNumber}</div>
        </div>

        {/* begin::Form group Email */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Email')}</label>
          <input
            placeholder={t('Enter Email')}
            type='email'
            id='email'
            autoComplete='off'
            className='form-control bg-transparent'
            value={props.email}
            onChange={(e: any) => {
              props.setEmail(e.target.value)
              props.removeError('email')
            }}
          />
          <div className='text-danger fw-bold'>{props.error[0].email}</div>
        </div>

        <div className='fv-row mb-8' data-kt-password-meter='true'>
          <div className='mb-1'>
            <label className='form-label fw-bolder text-dark fs-6 required'>{t('Password')}</label>
            <div className='position-relative mb-3'>
              <input
                type={props.passwordDisplay == true ? 'text' : 'password'}
                placeholder={t('Password')}
                id='password'
                autoComplete='off'
                className='form-control bg-transparent'
                value={props.password}
                onChange={(e: any) => {
                  props.setPassword(e.target.value)
                  props.removeError('password')
                }}
              />
              <span
                className='cursor-pointer'
                style={{position: 'absolute', top: '25%', right: '20px'}}
                title={props.passwordDisplay == true ? 'Hide' : 'Show'}
                onClick={() => props.setPasswordDisplay(!props.passwordDisplay)}
              >
                <FontAwesomeIcon icon={props.passwordDisplay == true ? faEyeSlash : faEye} />
              </span>
              <div className='fv-plugins-message-container invalid-feedback'></div>
              <div className='text-danger fw-bold'>{props.error[0].password}</div>
            </div>
            {/* begin::Meter */}
            <div
              className='d-flex align-items-center mb-3'
              data-kt-password-meter-control='highlight'
            >
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
            </div>
            {/* end::Meter */}
          </div>
          <div className='text-muted'>
            {t('Use 8 or more characters with a mix of letters, numbers & symbols.')}
          </div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group Confirm password */}
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6 required'>
            {t('Confirm Password')}
          </label>
          <div style={{position: 'relative'}}>
            <input
              type={props.confirmPasswordDisplay == true ? 'text' : 'password'}
              placeholder={t('Confirm Password')}
              id='confirmPassword'
              autoComplete='off'
              className='form-control bg-transparent'
              value={props.confirmPassword}
              onChange={(e: any) => {
                props.setConfirmPassword(e.target.value)
                props.removeError('confirmPassword')
              }}
            />
            <span
              className='cursor-pointer'
              style={{position: 'absolute', top: '25%', right: '20px'}}
              title={props.confirmPasswordDisplay == true ? 'Hide' : 'Show'}
              onClick={() => props.setConfirmPasswordDisplay(!props.confirmPasswordDisplay)}
            >
              <FontAwesomeIcon icon={props.confirmPasswordDisplay == true ? faEyeSlash : faEye} />
            </span>
            <div className='fv-plugins-message-container invalid-feedback'></div>
          </div>
          <div className='text-danger fw-bold'>{props.error[0].confirmPassword}</div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='text-center d-flex justify-content-center'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-lg btn-primary mb-5 me-3'
            onClick={props.registrationApi}
          >
            <span className='indicator-label'>{t('Submit')}</span>
            {props.loading && (
              <span className='indicator-progress'>
                {t('Please wait...')}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>

          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary mb-5'
            onClick={() => {
              props.onHide()
            }}
          >
            {t('Cancel')}
          </button>
        </div>
        {/* end::Form group */}
      </div>
    </>
  )
}
